export default __webpack_public_path__ + "static/hotblack-events3-0ed1cd87dd5db830906a18eafaed0611.jpg";